export const PROSPECTS = `
query prospects(
  $tenant_id: Int!,
  $skip: Int,
  $take: Int,
  $orderBy: ProspectOrderInput,
  $filter: ProspectFilterInput,
  $searchText: String
) {
  prospects(
    tenant_id: $tenant_id,
    skip: $skip,
    take: $take,
    orderBy: $orderBy,
    filter: $filter,
    searchText: $searchText
  ) {
    __typename
    ... on Prospect {
      id
      contact_id
      chair_id
      contact {
        id
        firstname
        lastname
        email
        secondary_email
        phone
        mobile
        city
        zip_code
        address
        province
        country
        identification_type_id
        identification
        birth_date
        gender
        exclude
        comments
        company_id
        position
        company {
          id
          name
          cuit
          province_id
          city
        }
        staff {
          id
        }
        member {
          id
        }
        chair {
          id
        }
        exhibitor {
          id
        }
        prospect {
          id
        }
        contact_contact_status {
          id
          status_id
          contact_type
          end_date
          status {
            id
            name
            hex_color
          }
        }
      }
      chair {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
      }
      its
      uts
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const CHAIR_PROSPECT_AVAILABILITY = `
query chairProspectAvailability($tenant_id: Int!, $chair_id: Int!) {
  chairProspectAvailability(tenant_id: $tenant_id, chair_id: $chair_id) {
    __typename
    ... on ChairProspectAvailability {
      count
      max
      available
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const PROSPECT_COUNT = `
query prospectsCount(
  $tenant_id: Int!,
  $orderBy: ProspectOrderInput,
  $filter: ProspectFilterInput,
  $searchText: String
) {
  prospectsCount(
    tenant_id: $tenant_id,
    orderBy: $orderBy,
    filter: $filter,
    searchText: $searchText
  ) {
    __typename
    ... on Count {
      count
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;
